import styled from 'styled-components';
import * as color from 'modules/common/theme/color';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  padding: 10px;
  border: ${(props) => (props.bordered ? '1px solid #e8e8e8' : 'none')};
  border-radius: 2px;

  .ant-radio-wrapper {
    align-items: center;
  }

  .ant-radio {
    margin-right: 8px;
  }
`;

const CreditWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: center;
  align-items: center;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Credit = styled.span`
  font-size: 16px;
  font-weight: 700;
`;

const Change = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #1890ff;
  cursor: pointer;
`;

const Description = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${color.LightHeadGray};
`;

const CardName = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

const CardImg = styled.img`
  width: 60px;
  height: 40px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${color.grayDot};
  border-radius: 50%;
  margin-right: 5px;
`;

const DotContainer = styled.div`
  display: flex;
  align-items: center;
`;

export default {
  Container,
  CreditWrapper,
  CardWrapper,
  Credit,
  Change,
  Description,
  CardImg,
  CardName,
  Dot,
  DotContainer,
};
